import {
  Button,
  Colors,
  Text,
  TypesButton,
  Typography,
} from 'goalsetter-webapp-components';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container,
  SendGoalCardContainer,
  SendGoalCardDescriptionContainer,
  titleWrapperStyle,
} from './styles';
import { buttonStyle } from 'app/components/UserItem/styles';
import { RoutesGs } from '../../../../router/RoutesList';
import DownloadApp from 'app/components/DownloadApp';
import { sendAnalyticsEvent } from '../../../../utils/analytics/analyticsWrapper';
import { ActionType, CategoryType } from '../../../../types/analytics/enum';
import PortalTitle from 'app/components/PortalTitle';
import LogoHeader from 'app/components/LogoHeader';
import { Flex } from '@mantine/core';

const SentSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const goToSendGoalcard = () => {
    sendAnalyticsEvent(
      CategoryType.sendGoalcardButton,
      ActionType.Goalcard_SendInvitation_SendGoalcardButton,
    );
    navigate(RoutesGs.SendGift);
  };

  return (
    <Container>
      <LogoHeader />
      <Flex style={titleWrapperStyle}>
        <PortalTitle translation="sentSuccess.title" />
      </Flex>
      <SendGoalCardContainer>
        <SendGoalCardDescriptionContainer>
          <Text
            type={Typography.GSSUBTITLE1}
            color={Colors.WHITE}
          >
            {t('sentSuccess.description', { destinationName: state.name })}
          </Text>
          <br></br>
          <Text
            type={Typography.GSSUBTITLE1}
            color={Colors.WHITE}
          >
            {t('sentSuccess.description_two')}
          </Text>
        </SendGoalCardDescriptionContainer>

        <>
          <Button
            type={TypesButton.PRIMARY}
            onClick={goToSendGoalcard}
            style={buttonStyle}
          >
            {t('sentSuccess.sendGoalcard')}
          </Button>
        </>
      </SendGoalCardContainer>

      <DownloadApp />
    </Container>
  );
};

export default SentSuccess;
